import Colors from '@/theme/constants/Colors';
import { Box, Button, Grid, Typography, styled } from '@mui/material';

export const ContainerDashboard = styled(Box)(({ theme }) => ({
  background: Colors.PRIMARY_ACCENT,
  position: 'relative',
  maxWidth: '100vw',
  minHeight: '100vh',
  paddingBottom: '20px',
}));

export const ContainerContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '65vw',
  marginInline: 'auto',
  flexDirection: 'column',
  position: 'relative',
  [theme.breakpoints.up('lg')]: {
    width: '60vw',
  },
}));

export const ContainerLogo = styled(Box)(({ theme }) => ({
  display: 'flex',
  paddingTop: '2%',
  justifyContent: 'space-between',
  alignItems: 'space-around',
  marginBottom: '2%',
  marginLeft: '20px',
  width: '100%',
  zIndex: '2',
}));

export const ButtonStyled = styled(Button)(({ theme }) => ({
  width: '100%',
  borderRadius: '56px',
  background: '#3AA05C',
  boxShadow: '0px 0px 18px 0px rgba(0, 0, 0, 0.16)',
  '&:hover': {
    background: '#3AA05C',
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  color: Colors.COLOR_WHITE_TEXT,
  fontFamily: 'Inter',
  fontSize: '24px',
  fontStyle: 'normal',
  fontWeight: '800',
  lineHeight: '36px',
}));
export const SubTitle = styled(Typography)(({ theme }) => ({
  color: Colors.COLOR_WHITE_TEXT,
  fontSize: '18px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '24px',
  letterSpacing: '0.2px',
  marginTop: '12px',
}));

export const ButtonLabel = styled(Typography)(({ theme }) => ({
  color: Colors.COLOR_WHITE_TEXT,
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '36px',
  fontSize: 'clamp(0,5rem,1rem, 2rem)',
  textTransform: 'none',
}));

export const ResetContainer = styled(Box)(() => ({
  height: '48px',
  width: '48px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#EDC2E2',
  borderRadius: '50%',
}));

export const GridContainerVideo = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '20px',
}));

export const BoxLogoutIcon = styled(Box)(() => ({
  width: '72px',
  height: '72px',
  borderRadius: '50%',
  backgroundColor: '#A03A7E',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
